var chunkToChildrenMap = {
	"9212": [
		4149,
		2604,
		721,
		5953,
		1535,
		4636,
		4222,
		6459,
		6225
	],
	"9806": [
		1378,
		507
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };